document.getElementById('order-traking-form').addEventListener('submit', function(event) {
    event.preventDefault();
    
    var email = document.getElementById('ContactForm-email').value;
    var orderNumber = document.getElementById('order-number').value;
    console.log("email: " + email);
    console.log("orderNumber: " + orderNumber);
    
    var xhr = new XMLHttpRequest();
    xhr.open("POST", "/apps/ac/order-tracking.php", true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

    xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
            try {
                var response = JSON.parse(xhr.responseText);
                
                // Clear previous error messages
                document.getElementById('error-message').textContent = '';
                
                if (response.tracking_url) {
                    window.location.href = response.tracking_url;
                } else {
                    // Display the error message in the designated container
                    document.getElementById('error-message').textContent = response.error;
                }
            } catch (error) {
                console.error("Failed to parse JSON response:", error);
                document.getElementById('error-message').textContent = 'An unexpected error occurred.';
            }
        }
    };

    var data = "email=" + encodeURIComponent(email) + "&orderNumber=" + encodeURIComponent(orderNumber);
    xhr.send(data);
});
